import MarketPhotoFullScreen from './src/main'

export default MarketPhotoFullScreen



// WEBPACK FOOTER //
// ./src/views/question-review/components/MarketPhotoFullScreen/index.js